import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
} from "@mui/material";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import TelegramIcon from "@mui/icons-material/Telegram";
import GitHubIcon from "@mui/icons-material/GitHub";

import logo from "../../assets/logo_white.svg";

const Footer = () => {
  const footerLinks = {
    Products: [
      { name: "Lendle", href: "https://lendle.xyz" },
      { name: "TAKOTAKO", href: "https://takotako.xyz" },
      { name: "GMXBT", href: "https://gmxbt.capital" },
    ],
    Company: [
      { name: "About Us", href: "#" },
      { name: "Contact", href: "#" },
    ],
    Legal: [
      { name: "Privacy Policy", href: "#" },
      { name: "Terms of Service", href: "#" },
      { name: "Disclaimer", href: "#" },
    ],
  };

  return (
    <Box sx={{ bgcolor: "#0A0A0A", color: "white", pt: 8, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={4}>
            {/* Logo and description */}
            <Box sx={{ mb: 6, pr: 8 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="b11a"
                  sx={{ height: 32 }}
                />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  b11a
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: "rgba(255, 255, 255, 0.7)",
                  maxWidth: "400px",
                  fontSize: "14px",
                  lineHeight: 1.6,
                }}
              >
                Leading the Future of Decentralized Finance through AI &
                Blockchain Innovation
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={8}>
            {/* Links */}
            <Grid container spacing={4} sx={{ mb: 6 }}>
              {Object.entries(footerLinks).map(([category, links]) => (
                <Grid item xs={12} sm={4} key={category}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "16px",
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    {category}
                  </Typography>
                  {links.map((link) => (
                    <Link
                      key={link.name}
                      href={link.href}
                      sx={{
                        display: "block",
                        color: "rgba(255, 255, 255, 0.7)",
                        textDecoration: "none",
                        fontSize: "14px",
                        mb: 1.5,
                        "&:hover": {
                          color: "white",
                        },
                      }}
                    >
                      {link.name}
                    </Link>
                  ))}
                </Grid>
              ))}
            </Grid>

            {/* Bottom bar */}
            <Box
              sx={{
                pt: 3,
                borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Typography
                sx={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px" }}
              >
                © 2025 b11a. All rights reserved.
              </Typography>

              <Box sx={{ display: "flex", gap: 1 }}>
                {/* <IconButton
                  href="https://twitter.com/b11aDefi"
                  target="_blank"
                  sx={{
                    color: "rgba(255, 255, 255, 0.7)",
                    "&:hover": { color: "white" },
                  }}
                >
                  <TwitterIcon sx={{ fontSize: 20 }} />
                </IconButton>
                <IconButton
                  href="https://t.me/b11aDefi"
                  target="_blank"
                  sx={{
                    color: "rgba(255, 255, 255, 0.7)",
                    "&:hover": { color: "white" },
                  }}
                >
                  <TelegramIcon sx={{ fontSize: 20 }} />
                </IconButton> */}
                <IconButton
                  href="https://github.com/0xb11a"
                  target="_blank"
                  sx={{
                    color: "rgba(255, 255, 255, 0.7)",
                    "&:hover": { color: "white" },
                  }}
                >
                  <GitHubIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
